import UniversalLoader from "./UniversalLoader.js";

/**
 * Instanzen dieser Klasse müssen createMaterial implementieren und können an UniversalLoader.setMaterialFactory
 * übergeben werden. Somit kann z.B. einmalig eine MTL Datei geladen werden, oder die Materialien werden
 * programmatisch erzeugt. Es können auch Factories per Delegation verkettet werden. Falls diese
 * Instanz kein Material liefert, wird an die delegateMaterialFactory weitergeleitet
 */
const Material_orig_copy= THREE.Material.prototype.copy;
THREE.Material.prototype.copy = function (source) {
    this._no_material_with_this_name_found=source._no_material_with_this_name_found;
    return Material_orig_copy.apply(this,arguments);
};


export default class AbstractMaterialFactory {

    /**
     * @param texture_root Der Basispfad, aus dem die Texturen geladen werden
     * @param delegateMaterialFactory Falls diese Instanz kein Material zu einem Namen liefert, wird an die delegateMaterialFactory weitergeleitet
     */
    constructor(texture_root,delegateMaterialFactory=null) {
        this.texture_root = texture_root;
        this.delegateMaterialFactory = delegateMaterialFactory;
        this.materials = {};
    }

    /**
     * Erzeugt ein Material zu einem Namen, falls es nicht im Cache ist.
     * Delegiert an die delegateMaterialFactory weiter, wenn createMaterial_(materialName) kein Material liefert.
     */
    create(materialName) {
        materialName = materialName || 'default';
        if (!this.materials[materialName]) {
            this.materials[materialName] = this._createMaterial(materialName);
        }
        if (!this.materials[materialName] && this.delegateMaterialFactory) {
            this.materials[materialName] = this.delegateMaterialFactory.create(materialName);
        }
        if (this.materials[materialName]==null) {
            this.materials[materialName] = new THREE.MeshStandardMaterial();
            this.materials[materialName].name = materialName;
            this.materials[materialName]._no_material_with_this_name_found = materialName;
            // logging ausgeschaltet, weil Normalfall bei externen Objekten mit enthaltenen Materialien (GTLF)
            // console.warn('MaterialFactory: found no material named '+materialName);
        }
        return this.materials[materialName];
    }

    /**
     * Muss überschrieben werden
     */
    _createMaterial(materialName) {
        throw "not yet implemented";
    }

    /** */
    loadTextureCube(images) {
        return UniversalLoader.loadTextureCube(images.map(img=>this.texture_root+img));
    }

    /** */
    loadTexture(path, onload) {
        let url = (/^(http|https|file):\/\/.*$/.test(path))
            ? path
            : this.texture_root + path;
        return UniversalLoader.loadTexture(url, undefined, onload);
    }

    /** */
    clearMaterialsCache() {
        this.materials = {};
    }

    /**
     * Muss überschrieben werden
     */
    getAllKnownMaterialNames() {
        throw "not yet implemented";
    }

}
